import { BaseDto } from "@app/modules/shared/model/base.dto";
import { CurrentAccountDto } from "@dashboard/modules/finance-management/current-account/model/current-account.dto";

export class InstallationUserDto extends BaseDto {
  status?: string;
  username?: string;
  full_name?: string;
  password?: string;
  current_account?: CurrentAccountDto;
}
